<template>
    <v-container>
        <v-row justify="center" class="mt-5">
            <v-col cols="12" sm="9">
                <v-form autocomplete="on" @submit.prevent="send">
                    <v-card>
                        <v-card-title>{{ $t('forgot_pw') }}</v-card-title>
                        <v-card-text>
                            <v-alert type="info" color="primary">{{ $t('forgot_pw_text') }}</v-alert>
                            <LabelField :label="$t('username')">
                                <v-text-field
                                    v-model="username"
                                    dense
                                    outlined
                                    :placeholder="$t('zb') + ' meierh'"
                                    autocomplete="on"
                                    :autofocus="true"
                                />
                            </LabelField>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <PlainBtn :to="{ name: 'login' }" :disabled="loading">{{ $t('cancel') }}</PlainBtn>
                            <ActionBtn
                                color="action white--text"
                                :loading="loading"
                                :disabled="loading || usernameIsEmpty"
                                type="submit"
                                @click.prevent="send"
                            >
                                {{ $t('absenden') }}
                            </ActionBtn>
                        </v-card-actions>

                        <v-fade-transition>
                            <v-card-text v-if="error">
                                <v-alert type="error">{{ error }}</v-alert>
                            </v-card-text>
                        </v-fade-transition>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { instance as api } from '@/helpers/api';

export default {
    name: 'ResetPassword',
    data() {
        return {
            username: '',
            loading: false,
            error: null,
        };
    },
    computed: {
        usernameIsEmpty() {
            return (this.username || '').trim().length === 0;
        },
    },
    methods: {
        async send() {
            try {
                this.loading = true;
                let ret = await api().post('/LoginLogout/forgotPassword', { username: this.username });
                if (ret && ret.data && ret.data.changed) {
                    this.$toast({ message: this.$t('forgot_pw_success'), color: 'success', timeout: 8000 });
                    this.$router.replace({ name: 'login' });
                } else {
                    this.loading = false;
                }
            } catch (e) {
                this.loading = false;
                this.error = e;
            }
        },
    },
};
</script>
